export function truncateWithEllipsis(text: string, maxLength: number): string {
  const ellipsis = "・・・・";

  if (!text || typeof text !== "string") {
    return "";
  }

  if (text.length <= maxLength) {
    return text;
  }

  const truncatedLength = maxLength - ellipsis.length;
  return text.slice(0, Math.max(truncatedLength, 0)) + ellipsis;
}
